import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Wrench, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ActionForm } from "@/components/opening/OpeningReports";

function Shell({ tone, icon: Icon, title, sub, testId, children }) {
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent overlayClassName="z-[100]" className={`z-[100] bg-slate-900 border-2 ${tone[0]} max-w-md [&>button]:hidden`} onInteractOutside={(e) => e.preventDefault()}
                     onEscapeKeyDown={(e) => e.preventDefault()} data-testid={testId}>
        <DialogHeader>
          <div className={`mx-auto h-16 w-16 rounded-2xl border flex items-center justify-center mb-2 ${tone[1]}`}><Icon size={30} /></div>
          <DialogTitle className={`text-center font-display text-2xl ${tone[2]}`}>{title}</DialogTitle>
          {sub && <p className="text-center text-sm text-slate-400">{sub}</p>}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}

const RED = ["border-red-500/60", "bg-red-500/15 border-red-500/40 text-red-400", "text-red-300"];
const GREEN = ["border-emerald-500/60", "bg-emerald-500/15 border-emerald-500/40 text-emerald-400", "text-emerald-300"];
const AMBER = ["border-amber-500/60", "bg-amber-500/15 border-amber-500/40 text-amber-400", "text-amber-300"];

function Detail({ m }) {
  return (
    <div className="rounded-xl bg-slate-950/60 border border-slate-800 divide-y divide-slate-800 text-sm">
      {[["Soru", m.question], ["Açıklama", m.note], ...(m.action ? [["Aksiyon", m.action]] : [])].map(([k, v]) => (
        <div key={k} className="px-4 py-2"><div className="text-[11px] text-slate-500">{k}</div><div className="font-medium">{v || "-"}</div></div>
      ))}
    </div>
  );
}

function Footer({ rest, ack, label = "Tamam", testId }) {
  return (
    <div className="space-y-2">
      {rest > 0 && <p className="text-center text-xs text-slate-500">{rest} bildirim daha var</p>}
      <Button onClick={ack} className="w-full py-5 bg-blue-600 hover:bg-blue-500" data-testid={testId}>{label}</Button>
    </div>
  );
}

export function OpeningIssueAlert({ m, rest, ack }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const canAct = user?.role === "mudur";
  return (
    <Shell tone={RED} icon={AlertTriangle} title="Açılış Listesinde Sorun" sub={`${m.branch_name} · ${m.by} işaretledi`} testId="opening-issue-alert">
      <Detail m={m} />
      {canAct ? (
        <>
          <ActionForm cid={m.checklist_id} qid={m.qid} onSaved={ack} testId="opening-issue-action" />
          {rest > 0 && <p className="text-center text-xs text-slate-500">{rest} bildirim daha var</p>}
          <div className="text-center"><button onClick={ack} className="text-xs text-slate-500 hover:text-slate-300" data-testid="opening-issue-later">Sonra yazacağım (Açılış Listesi › Raporlar)</button></div>
        </>
      ) : <Footer rest={rest} ack={() => { ack(); }} testId="opening-issue-ok" />}
      {!canAct && <div className="text-center"><button onClick={() => { ack(); nav("/opening"); }} className="text-xs text-blue-300 hover:underline" data-testid="opening-issue-open">Raporu aç</button></div>}
    </Shell>
  );
}

export function OpeningActionAlert({ m, rest, ack }) {
  return (
    <Shell tone={GREEN} icon={Wrench} title="Aksiyon Alındı" sub={`${m.branch_name} · ${m.by}`} testId="opening-action-alert">
      <Detail m={m} />
      <Footer rest={rest} ack={ack} testId="opening-action-ok" />
    </Shell>
  );
}

export function OpeningOverdueAlert({ m, rest, ack }) {
  return (
    <Shell tone={AMBER} icon={Clock} title="Açılış Listesi Doldurulmadı" sub={`${m.branch_name} · açılış ${m.open_time}`} testId="opening-overdue-alert">
      <p className="text-center text-sm text-slate-300">Açılıştan sonraki 30 dakika içinde açılış listesi doldurulmadı.</p>
      <Footer rest={rest} ack={ack} testId="opening-overdue-ok" />
    </Shell>
  );
}
